import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StepperKnobDirective } from './stepper-knob/stepper-knob.directive';
import { StepperLineBaseDirective } from './stepper-line/stepper-line-base/stepper-line-base.directive';
import { StepperLineDirective } from './stepper-line/stepper-line.directive';
import { StepperKnobIndicatorDirective } from './stepper-knob/stepper-knob-indicator/stepper-knob-indicator.directive';
import { StepperKnobTextDirective } from './stepper-knob/stepper-knob-text/stepper-knob-text.directive';
import { StepperComponent } from './stepper.component';

@NgModule({
  declarations: [
    StepperKnobDirective,
    StepperKnobIndicatorDirective,
    StepperKnobTextDirective,
    StepperLineBaseDirective,
    StepperLineDirective,
    StepperComponent,
  ],
  imports: [CommonModule],
  exports: [
    StepperKnobDirective,
    StepperKnobIndicatorDirective,
    StepperKnobTextDirective,
    StepperLineBaseDirective,
    StepperLineDirective,
    StepperComponent,
  ],
})
export class StepperModule {}
